import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Ad from '@ifeng-fe/ui_pc_ad';

import TitleWrap from './titleWrap';
import PlayerBox from './playerBox';
import AuthorInfo from './authorInfo';
import AuthorOtherInfo from './authorOtherInfo';
import HotTopic from './hotTopic';
import BookRecommendSlide from './bookRecommendSlide';
import AudioTopic from './audioTopic';
import CommentArea from './commentArea';
import RankingList from './rankingList';
import Chip from 'Chip';
// import AdBox from './adBox';
import NoSSR from 'react-no-ssr';

import { getImage } from '../../utils/cutImg';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        docData: PropTypes.object,
        ad: PropTypes.object,
    };

    state = {
        minScreen: false,
    };

    componentDidMount() {
        // if (document.body.clientWidth < 1300) {
        //     this.setState({
        //         minScreen: true,
        //     });
        // }
        // throttle(this.resizeListener()); // 包裹节流函数
    }

    // 自适应宽窄屏
    // resizeListener = () => {
    //     window.addEventListener('resize', () => {
    //         const docW = document.body.clientWidth;

    //         if (docW < 1300) {
    //             this.setState({
    //                 minScreen: true,
    //             });
    //         } else {
    //             this.setState({
    //                 minScreen: false,
    //             });
    //         }
    //     });
    // };

    render() {
        const { content, docData, ad } = this.props;
        const {
            vSource,
            hotTopics,
            rankingList,
            relatedVideos,
            videoStream,
            allVideoStream,
            parentColumn,
            wemediaEAccountId,
            fhhAccountDetail,
            bookRecommendData,
            audioTopics,
            playerUtils,
            isHitBlack,
            hasRelatedRecommend,
            interact,
            hotRecommond,
        } = content;
        const { title, breadCrumbdata, newsTime, duration, guid, columnName, posterUrl, hasCopyRight, subscribe, sourceAlias, sourceReason } = docData;
        const titleData = {
            vSource,
            title,
            breadCrumbdata,
            newsTime,
            duration,
            guid,
            wemediaEAccountId,
            columnName,
            subscribe,
        };
        const relatedVideosData = {
            relatedVideos,
            videoStream,
            allVideoStream,
        };
        const { bannertopAd, streamListAd, bannerAd01, rectangleAd01, bannerAd02, picAndTxt, bannerAd03, rectangleAd02, rectangleAd03, hotTopicsAd } = ad;

        const { minScreen } = this.state;

        const noSsrDom = (
            <div className={styles.nossr_playerBox}>
                <div className={styles.nossr_playerContainer}>
                    <img src={posterUrl} alt={title} title={title} style={{ width: 930, height: 528 }} />
                </div>
            </div>
        );

        return (
            <div className={`${styles.content} ${minScreen ? styles.min_content : ''}`}>
                {/* <div style={{ width: 121, margin: '0 auto' }}>
                    <table style={{ visibility: 'collapse' }}>
                        <tr>
                            <td>
                                <img
                                    width="121"
                                    height="75"
                                    src={docData.posterUrl && getImage(docData.posterUrl, 121, 75)}
                                    title={docData.title}
                                    alt={docData.title}
                                />
                            </td>
                        </tr>
                    </table>
                </div> */}
                <TitleWrap content={titleData} ads={bannertopAd} />
                <NoSSR onSSR={noSsrDom}>
                    <PlayerBox
                        content={docData}
                        playerUtils={playerUtils}
                        relatedVideosData={relatedVideosData}
                        parentColumn={parentColumn}
                        ads={streamListAd}
                        minScreen={minScreen}
                        isHitBlack={isHitBlack}
                        hasRelatedRecommend={hasRelatedRecommend}
                        interact={interact}
                    />
                    <div className={`${styles.relevantContent} clearfix`}>
                        <div className={`${styles.leftPart} ${minScreen ? styles.min_leftPart : ''}`}>
                            {docData.summary ? <div className={styles.brief}>{docData.summary}</div> : ''}
                            {hasCopyRight ? (
                                <div className={styles.copyRight}>
                                    <p className={styles.copyRightCh}>
                                        “特别声明：以上作品内容(包括在内的视频、图片或音频)为凤凰网旗下自媒体平台“大风号”用户上传并发布，本平台仅提供信息存储空间服务。
                                    </p>
                                    <p className={styles.copyRightZh}>
                                        Notice: The content above (including the videos, pictures and audios if any) is uploaded and posted by the user of Dafeng Hao, which is a social media platform
                                        and merely provides information storage space services.”
                                    </p>
                                </div>
                            ) : (
                                ''
                            )}
                            <div className={styles.ad_mt50}>
                                <NoSSR>
                                    <Ad content={bannerAd01} />
                                </NoSSR>
                            </div>
                            {fhhAccountDetail && Object.keys(fhhAccountDetail).length > 0 && wemediaEAccountId ? (
                                <AuthorInfo wemediaEAccountId={wemediaEAccountId} fhhAccountDetail={fhhAccountDetail} />
                            ) : (
                                <AuthorOtherInfo sourceAlias={sourceAlias} sourceReason={sourceReason} />
                            )}
                            {!isHitBlack && (
                                <Chip id="75179" type="recommend" title="视频播放页-热播推荐" groupName="正文" translate="handleHotTopics" content={hotTopics}>
                                    <HotTopic minScreen={minScreen} ad={hotTopicsAd} hotRecommond={hotRecommond} />
                                </Chip>
                            )}
                            <Ad content={bannerAd02} />
                            {/* <AdBox ads={picAndTxt} minScreen={minScreen} /> */}
                            {/* <div className={styles.bannerAd03}>
                            <Ad content={bannerAd03} />
                        </div> */}
                            {!isHitBlack && <BookRecommendSlide bookRecommendData={bookRecommendData} ad={{}} />}
                            {!isHitBlack && (
                                <Chip id="225122" type="recommend" title="视频播放页-精品有声" groupName="正文" content={audioTopics}>
                                    <AudioTopic />
                                </Chip>
                            )}
                            <CommentArea content={docData} />
                        </div>
                        <div className={styles.rightPart}>
                            <div className={styles.rectangleAd01}>
                                <NoSSR>
                                    <Ad content={rectangleAd01} />
                                </NoSSR>
                            </div>
                            {!isHitBlack && <RankingList content={rankingList} />}
                            <div className={styles.ad}>
                                <NoSSR>
                                    <Ad content={rectangleAd02} />
                                </NoSSR>
                            </div>
                            <div className={styles.ad}>
                                <NoSSR>
                                    <Ad content={rectangleAd03} />
                                </NoSSR>
                            </div>
                        </div>
                    </div>
                </NoSSR>
            </div>
        );
    }
}

export default errorBoundary(Content);
